module.exports = __webpack_public_path__ + "img/product2-2.39e1bbf9.jpg";